import '@hotwired/turbo-rails'

import 'trix'
import '@rails/actiontext'
import * as ActiveStorage from '@rails/activestorage'
import '@quis-de/fontawesome-pro/js/fontawesome'
import '@quis-de/fontawesome-pro/js/duotone'
// require("channels")

// Stimulus
import './controllers'

ActiveStorage.start()
